<template>
  <div class="guide">
    <img class="guide-img" src="../assets/imgs/openinbrowser.png" alt="">
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.guide {
  background: rgba($color: #000, $alpha: 0.7);
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 10000;

  &-img {
    margin: 131px 0 0 100px;
    width: 579px;
  }
}
</style>